import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getStockReceiptApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (code === 'STOCK_RECEIPT_NOT_FOUND' || code === 'RESOURCE_NOT_FOUND') {
    return data?.message || '找不到入庫單資料';
  }

  if (code === 'STOCK_RECEIPT_TWD_CURRENCY_UNAVAILABLE') {
    return data?.message || '系統找不到可用的 TWD 幣別或其匯率無效，請管理員修正幣別主檔後再試';
  }

  if (code === 'STOCK_RECEIPT_HEADER_CHARGE_INVALID') {
    return data?.message || '關稅或運費須為 0 以上，最多兩位小數';
  }

  return data?.message || fallback;
}

export function isStockReceiptVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
